if (!customElements.get('wlsn-faq-page')) {
  class WLSNFaqPage extends HTMLElement {
    constructor() {
      super();

      this.classes = {
        tab: 'js-wlsn-faq-page-tab',
        panel: 'js-wlsn-faq-page-panel',
      };

      this.boundOnTabClick = this._onTabClick.bind(this);
    }

    get elements() {
      return {
        tabs: this.querySelectorAll(`.${this.classes.tab}`),
        panels: this.querySelectorAll(`.${this.classes.panel}`),
      };
    }

    connectedCallback() {
      this.elements.tabs.forEach((tab) => {
        tab.addEventListener('click', this.boundOnTabClick);
      });
    }

    disconnectedCallback() {
      this.elements.tabs.forEach((tab) => {
        tab.removeEventListener('click', this.boundOnTabClick);
      });
    }

    _onTabClick(event) {
      const tab = event.currentTarget;
      const tabId = tab.getAttribute('data-tab-id');
      if (!tabId) return;

      this._activateTab(tabId);
    }

    _activateTab(tabId) {
      const { tabs, panels } = this.elements;

      tabs.forEach((tab) => {
        const isActive = tab.getAttribute('data-tab-id') === tabId;
        if (isActive) {
          tab.setAttribute('data-active', 'true');
          tab.setAttribute('aria-selected', 'true');
        } else {
          tab.removeAttribute('data-active');
          tab.setAttribute('aria-selected', 'false');
        }
      });

      panels.forEach((panel) => {
        const isActive = panel.getAttribute('data-panel-id') === tabId;
        if (isActive) {
          panel.setAttribute('data-active', 'true');
          panel.removeAttribute('hidden');
        } else {
          panel.removeAttribute('data-active');
          panel.setAttribute('hidden', '');
        }
      });
    }
  }

  customElements.define('wlsn-faq-page', WLSNFaqPage);
}
